import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useCallback } from 'react';

import { Organisation, organisationsApi } from '../../api';
import OrganisationsPage from './OrganisationsPage/OrganisationsPage';

const OrganisationsContainer: React.FC = () => { 
  const [organisations, setOrganisations] = useState<Organisation[]>([]);
  const [loading, setLoading]= useState(true);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const fetchOrganisations = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await organisationsApi.list({
        q: searchQuery || undefined,
        limit: 100,
      });
      setOrganisations(response.data.items);
    } catch (err) {
      console.error('Failed to fetch organisations:', err);
      setError('Failed to fetch organisations');
    } finally { 
      setLoading(false);
    }
  }, [searchQuery]);

  useEffect(() => { fetchOrganisations(); }, [fetchOrganisations]);

  const handleDelete = async (organisationId: string) => {
    if (!window.confirm('Are you sure you want to delete this organisation? This action cannot be undone.')) {
      return;
    }

    try {
      await organisationsApi.delete(organisationId);
      fetchOrganisations();
    } catch (err) {
      console.error('Failed to delete organisation:', err);
      alert('Failed to delete organisation. It may have associated users or guidelines.');
    }
  };

  const handleViewDetails = (organisationId: string) => {
    navigate(`/organisations/${organisationId}`);
  };

  return (
    <OrganisationsPage
      organisations={organisations}
      loading={loading}
      error={error}
      searchQuery={searchQuery}
      onSearchChange={setSearchQuery}
      onDelete={handleDelete}
      onViewDetails={handleViewDetails}
      onRefresh={fetchOrganisations}
    />
  );
};

export default OrganisationsContainer;